import { GoogleMap, Marker } from "@react-google-maps/api";
import CircularProgress from '@material-ui/core/CircularProgress';
import { Grid, Box } from "@material-ui/core";

const wrapperStyle = {
    width: '100%',
    height: '250px',
    position: 'relative',
    background: '#b8b8b8'
}
const containerStyle = {
    ...wrapperStyle,
    margin: 0,
};
const loadingStyle = {
    background: '#999',
    borderRadius: '4px',
    display: 'flex',
    position: 'absolute',
    top: 0,
    left: 0,
    opacitiy: '0.4',
    zIndex: 10,
    justifyContent: 'center',
    alignItems: 'center'
}
const defaultCenter = {
    lat: 25.2048,
    lng: 55.2708,
}
export default function PlacePicker({ location, disabled=false ,loading, onChange }) {
    const onClick = ({ latLng }) => {
        const lat = latLng.lat();
        const lng = latLng.lng();
        onChange({ lat, lng });
    }
    if(disabled){
        return (
            <div class="wrapper" style={wrapperStyle}>

            
        </div>
        );
    }
    return (
        <div class="wrapper" style={wrapperStyle}>
            {loading && <div style={{ ...containerStyle, ...loadingStyle }}>
                <CircularProgress color="secondary" />
            </div>}
            <GoogleMap
                
                id="marker-example"
                mapContainerStyle={containerStyle}
                onClick={onClick}
                zoom={18}
                center={location || defaultCenter}
            >
                <Marker position={location} />
            </GoogleMap>
        </div>
    );
}